"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var GermanNumberFormat = function GermanNumberFormat(number) {
  return number.toFixed().replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
};

var _default = GermanNumberFormat;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9OdW1iZXJVdGlsL0dlcm1hbk51bWJlckZvcm1hdC50cyJdLCJuYW1lcyI6WyJHZXJtYW5OdW1iZXJGb3JtYXQiLCJudW1iZXIiLCJ0b0ZpeGVkIiwicmVwbGFjZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBLElBQU1BLGtCQUFrQixHQUFHLFNBQXJCQSxrQkFBcUIsQ0FBQ0MsTUFBRDtBQUFBLFNBQTRCQSxNQUFNLENBQUNDLE9BQVAsR0FDcERDLE9BRG9ELENBQzVDLEdBRDRDLEVBQ3ZDLEdBRHVDLEVBRXBEQSxPQUZvRCxDQUU1Qyx5QkFGNEMsRUFFakIsS0FGaUIsQ0FBNUI7QUFBQSxDQUEzQjs7ZUFJZUgsa0IiLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCBHZXJtYW5OdW1iZXJGb3JtYXQgPSAobnVtYmVyOiBudW1iZXIpOiBzdHJpbmcgPT4gbnVtYmVyLnRvRml4ZWQoKVxuICAucmVwbGFjZSgnLicsICcsJylcbiAgLnJlcGxhY2UoLyhcXGQpKD89KFxcZHszfSkrKD8hXFxkKSkvZywgJyQxLicpO1xuXG5leHBvcnQgZGVmYXVsdCBHZXJtYW5OdW1iZXJGb3JtYXQ7XG4iXX0=